import { createReducer } from 'redux-act';
import * as actions from '#app/actions/transferCommission';

interface TransferCommissionState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  transferId: number | null;
}

const initialState: TransferCommissionState = {
  modalVisible: false,
  form: {},
  transferId: null,
};

const setTransferCommissionModalVisible = (
  state: TransferCommissionState,
  bool: boolean
): TransferCommissionState => ({
  ...state,
  modalVisible: bool,
});

const setTransferId = (
  state: TransferCommissionState,
  transferId: number | null
): TransferCommissionState => ({
  ...state,
  transferId: transferId,
});

const setTransferCommissionForm = (
  state: TransferCommissionState,
  form: Record<string, unknown>
): TransferCommissionState => ({
  ...state,
  form: form,
});

export default createReducer<TransferCommissionState>(
  {
    [actions.setTransferCommissionModalVisible as any]: setTransferCommissionModalVisible,
    [actions.setTransferCommissionForm as any]: setTransferCommissionForm,
    [actions.setTransferId as any]: setTransferId,
  },
  initialState
);
